// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"f583cf95","376":"d8bf1ab7","622":"e09e07ad","896":"224a37ca"}[chunkId] + ".chunk.css";
};